var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "marketingProjectManagement" }, [
    _c(
      "div",
      { staticClass: "realTaskAll" },
      [
        _c("realTaskmenu", {
          attrs: { reception: _vm.returnParameters, cutValue: _vm.cut_result },
          on: { cut: _vm.cut }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _vm.cut_result == 1
            ? _c(
                "div",
                { staticStyle: { height: "100%" } },
                [
                  _c("classCompany", {
                    attrs: { classCompany: _vm.classCompany },
                    on: {
                      name: function($event) {
                        return _vm.myfuntion()
                      }
                    }
                  })
                ],
                1
              )
            : _vm.cut_result == 2
            ? _c(
                "div",
                { staticStyle: { height: "100%" } },
                [
                  _c("marketProjectReview", {
                    attrs: { marketProjectReview: _vm.marketProjectReview },
                    on: {
                      name: function($event) {
                        return _vm.myfuntion()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9256015a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9256015a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/auditNewRealTask/marketingProjectManagement.vue
// module id = null
// module chunks = 